/* tslint:disable */
/* eslint-disable */
/**
 * PostgREST API
 * This is a dynamic API generated by PostgREST
 *
 * The version of the OpenAPI document: 10.1.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OdysUser
 */
export interface OdysUser {
    /**
     * Note:
     * This is a Primary Key.<pk/>
     * @type {string}
     * @memberof OdysUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OdysUser
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OdysUser
     */
    updatedAt: string;
}

export function OdysUserFromJSON(json: any): OdysUser {
    return OdysUserFromJSONTyped(json, false);
}

export function OdysUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdysUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function OdysUserToJSON(value?: OdysUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
    };
}


